export default "__VITE_ASSET__Cvs2V7k4__"